<div class="bp-modal mod-lg wrapper">
	<bp-modal-header [title]="'address_book_deposit_on_hold' | translate" class="font-semibold">
		<button class="cancel-button" left (click)="back()" (keydown.enter)="back()" [tabIndex]="0">
			@if (!hasWalletHost) {
				<strong>{{ "back" | translate }}</strong>
			}
		</button>
		<button class="cancel-button" right (click)="cancel()" (keydown.enter)="cancel()" [tabIndex]="0">
			@if (!hasWalletHost) {
				<strong>{{ "cancel" | translate }}</strong>
			}
		</button>
	</bp-modal-header>

	<div class="bp-modal-body">
		<div class="bp-modal-description">
			<div class="header">
				@if (!hasWalletHost) {
					<h2>{{ "deposit_validation_owner_type_title" | translate }}</h2>
					<span class="title-description">{{ "travel_rule_wallet_type_subtitle" | translate }}</span>
				} @else {
					<h2>{{ "address_book_processing_information" | translate }}</h2>
					<span class="title-description">{{ "address_book_confirmation_of_verification" | translate }}</span>
				}
			</div>
		</div>

		@if (!hasWalletHost) {
			<div class="bp-modal-body-section">
				<div class="wallet-type-options">
					<div
						class="wallet-type-option"
						(click)="selectOption(onHoldWalletSelection.EXCHANGE)"
						[tabIndex]="0"
						(keydown.enter)="selectOption(onHoldWalletSelection.EXCHANGE)">
						<div class="option-icon">
							<svg-inline src="assets/images/icons/bank.svg" alt="" />
						</div>
						<div class="option-content">
							<h3 class="option-title">{{
								"travel_rule_wallet_type_wallet_on_exchange_title" | translate
							}}</h3>
							<p class="option-description">{{
								"travel_rule_wallet_type_wallet_on_exchange_subtitle" | translate
							}}</p>
						</div>
						<div class="option-arrow">
							<span class="bpi__icon-caret-right"></span>
						</div>
					</div>

					<div
						class="wallet-type-option"
						(click)="selectOption(onHoldWalletSelection.SELF_HOSTED_OWN)"
						[tabIndex]="0"
						(keydown.enter)="selectOption(onHoldWalletSelection.SELF_HOSTED_OWN)">
						<div class="option-icon">
							<svg-inline src="assets/images/icons/user-key.svg" alt="" />
						</div>
						<div class="option-content">
							<h3 class="option-title">{{
								"travel_rule_wallet_type_private_wallet_title" | translate
							}}</h3>
							<p class="option-description">{{
								"travel_rule_wallet_type_private_wallet_subtitle" | translate
							}}</p>
						</div>
						<div class="option-arrow">
							<span class="bpi__icon-caret-right"></span>
						</div>
					</div>

					<div
						class="wallet-type-option"
						(click)="selectOption(onHoldWalletSelection.SELF_HOSTED_3RD_PARTY)"
						[tabIndex]="0"
						(keydown.enter)="selectOption(onHoldWalletSelection.SELF_HOSTED_3RD_PARTY)">
						<div class="option-icon">
							<svg-inline src="assets/images/icons/persons.svg" alt="" />
						</div>
						<div class="option-content">
							<h3 class="option-title">{{
								"travel_rule_wallet_type_other_person_wallet_title" | translate
							}}</h3>
							<p class="option-description">{{
								"travel_rule_wallet_type_other_person_wallet_subtitle" | translate
							}}</p>
						</div>
						<div class="option-arrow">
							<span class="bpi__icon-caret-right"></span>
						</div>
					</div>
				</div>
			</div>
		} @else {
			<div class="bp-modal-body-section">
				<button (click)="cancel()" type="button" class="btn btn-primary save-wallet-btn">
					{{ "ok" | translate }}
				</button>
			</div>
		}
	</div>
</div>
